"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[93],{

/***/ 4847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useImageDataHandler; }
/* harmony export */ });
/* unused harmony export imageDataHandler */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _contexts_ViewportContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9366);
/* harmony import */ var _util_magnolia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7581);
/* harmony import */ var _util_viewport__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5625);





/**
 * Hook to generate an image handler function.
 *
 * Options can be passed to handler function to optimise image size.
 * If the image does not to bigger than "sm" in any viewport, then
 * `maxViewport` option should be set to `Viewport.sm`.
 *
 * Image sizes (width) for each viewport size:
 * - xs: 600px
 * - sm: 800px
 * - md: 900px
 * - lg: 1024px
 * - xl: 1440px
 */ function useImageDataHandler() {
    var isPreview = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().isPreview;
    var viewport = (0,_contexts_ViewportContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().viewport;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(image, options) {
        return imageDataHandler(image, viewport, isPreview, options);
    }, [
        isPreview,
        viewport
    ]);
}
/**
 * Get image information from MGNL (MGNL = Magnolia)
 * @param image - Image object from MGNL
 * @param viewport - Viewport from store
 * @returns Object containing "imageSrc" (image url), "imageLoader" (loader to handle next/image)
 *  and boolean "fallback", to show a fallback image if current image is not published in MGNL
 */ function imageDataHandler(image, viewport) {
    var isPreview = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, options = arguments.length > 3 ? arguments[3] : void 0;
    if (typeof image === "string" || !image) return {
        src: "",
        width: 0,
        height: 0,
        imageLoader: undefined,
        imageSrc: ""
    };
    var _metadata = image.metadata, width = _metadata.width, height = _metadata.height;
    var src = (0,_util_magnolia__WEBPACK_IMPORTED_MODULE_3__/* .formatAssetLink */ .Qz)(image["@link"], isPreview).toString();
    var optimisedViewport = (0,_util_viewport__WEBPACK_IMPORTED_MODULE_4__/* .optimiseViewport */ .s)(viewport, options);
    var imageLoader = function() {
        var ref;
        return optimisedViewport && ((ref = image.renditions) === null || ref === void 0 ? void 0 : ref[optimisedViewport].link) ? (0,_util_magnolia__WEBPACK_IMPORTED_MODULE_3__/* .formatAssetLink */ .Qz)(image.renditions[optimisedViewport].link, isPreview) : src;
    };
    return {
        src: src,
        width: width,
        height: height,
        imageLoader: imageLoader,
        imageSrc: src
    };
}


/***/ }),

/***/ 1460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ CTABanner; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useKeyDown-88662051.mjs
var useKeyDown_88662051 = __webpack_require__(403);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-51178863.mjs
var app_51178863 = __webpack_require__(7610);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useClickOutside-55c64a80.mjs
var useClickOutside_55c64a80 = __webpack_require__(7720);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-be3826ec.mjs
var Image_be3826ec = __webpack_require__(567);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-460da2fc.mjs
var Link_460da2fc = __webpack_require__(1607);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Button-eec2778c.mjs
var Button_eec2778c = __webpack_require__(9358);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/CTABanner.js










const E = "ctaBanner", y = "ctaBanner__image", h = "ctaBanner__content", x = "ctaBanner__button-container", _ = "ctaBanner__credits";
const f = "ctaBanner--has-image", b = "ctaBanner--employer", k = "ctaBanner--button-only";
const w = (i) => {
  const { headline: r, body: c, image: t, link: o, btnText: l } = i, d = (0,app_51178863.u)();
  return /* @__PURE__ */ react.createElement(
    useClickOutside_55c64a80.B,
    {
      topPadding: useClickOutside_55c64a80.B.Padding.LARGE,
      bottomPadding: useClickOutside_55c64a80.B.Padding.LARGE,
      className: (0,useKeyDown_88662051.c)(
        E,
        d && b,
        !!t && f,
        !r && !c && k
      ),
      "data-testid": "cta-banner-block"
    },
    t && /* @__PURE__ */ react.createElement(
      Image_be3826ec.I,
      {
        credits: t.credits,
        src: t.src,
        width: t.width,
        height: t.height,
        altText: t.altText,
        imageLoader: t.imageLoader,
        className: y,
        styling: Image_be3826ec.a.PREVIEW_CARD,
        "data-testid": "cta-banner-image"
      }
    ),
    /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B.Content, { flex: !0, className: h }, !!r && /* @__PURE__ */ react.createElement("h2", { className: (0,useKeyDown_88662051.c)(useKeyDown_88662051.t.headingSection) }, r), !!c && /* @__PURE__ */ react.createElement("p", { className: (0,useKeyDown_88662051.c)(useKeyDown_88662051.t.textsLeadText) }, c), /* @__PURE__ */ react.createElement("div", { className: x }, /* @__PURE__ */ react.createElement(
      Link_460da2fc.L,
      {
        className: Button_eec2778c.B.PrimaryFocusStyleInLink,
        href: o.href,
        target: o.isExternalLink ? "_blank" : void 0,
        disableLinkTextStyle: !0,
        itemProp: "url"
      },
      /* @__PURE__ */ react.createElement(
        Button_eec2778c.B.Primary,
        {
          text: l || o.title,
          asDiv: !0
        }
      )
    ))),
    t && /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B.Content, { flex: !0, className: _ }, /* @__PURE__ */ react.createElement("div", { className: (0,useKeyDown_88662051.c)(useKeyDown_88662051.t.buttonTextPrimary) }, t.credits))
  );
};

//# sourceMappingURL=CTABanner.js.map

// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/CTABanner/CTABanner.tsx






var transformLink = function(ctaBannerType) {
    var resolvedLink = (0,magnolia/* resolveLinkSwitchableField */.cJ)(ctaBannerType.link, false);
    return {
        title: ctaBannerType.btnText,
        href: resolvedLink.linkHref,
        isExternalLink: resolvedLink.isExternalLink
    };
};
function CTABanner(param) {
    var ctaBannerType = param.ctaBannerType;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var props = {
        link: transformLink(ctaBannerType),
        btnText: ctaBannerType.btnText
    };
    if (ctaBannerType.field === "default" || ctaBannerType.field === "imageBackground") {
        props.headline = ctaBannerType.headline;
        props.body = ctaBannerType.bodyText;
    }
    if (ctaBannerType.field === "imageBackground") {
        var imageData = imageDataHandler(ctaBannerType.image);
        props.image = (0,_object_spread/* default */.Z)({
            credits: ctaBannerType.imageCredit || ctaBannerType.image.metadata.rights,
            altText: ctaBannerType.imageAlt || ctaBannerType.image.metadata.title || ""
        }, imageData);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(w, (0,_object_spread/* default */.Z)({}, props));
}

;// CONCATENATED MODULE: ./src/magnolia/components/CTABanner/index.ts
/* istanbul ignore file */ 


/***/ })

}]);